function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.611,19.507V19.45a.569.569,0,0,0,0-.2.471.471,0,0,0-.041-.114.812.812,0,0,0-.13-.195h0l-1.624-1.624a.815.815,0,0,0-1.153,1.153l.244.235H18.283l-.763-1.527-.909,1.811.447.893a.812.812,0,0,0,.682.382h2.1L19.6,20.5a.815.815,0,1,0,1.153,1.153l1.624-1.624a.65.65,0,0,0,.154-.244.341.341,0,0,0,0-.081A.812.812,0,0,0,22.611,19.507Z",
  transform: "translate(-9.619 -10.482)",
  fill: "#9f9a92"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.812,12.624h3.557l.763,1.527.909-1.811-.447-.893A.812.812,0,0,0,12.872,11H8.812a.812.812,0,1,0,0,1.624Z",
  transform: "translate(-8 -9.34)",
  fill: "#9f9a92"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.223,12.24l-.244.235a.815.815,0,1,0,1.153,1.153L20.757,12h0a.69.69,0,0,0,.154-.244h0a.69.69,0,0,0,.081-.333v-.081a.813.813,0,0,0,0-.2.244.244,0,0,0,0-.081.812.812,0,0,0-.154-.244L19.214,9.195a.815.815,0,1,0-1.153,1.153l.244.235H16.12a.812.812,0,0,0-.723.447l-3.029,6.082H8.812a.812.812,0,0,0,0,1.624h4.06a.812.812,0,0,0,.723-.447l3.029-6.049Z",
  transform: "translate(-8 -8.956)",
  fill: "#9f9a92"
}));

function SvgShuffle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.001,
    height: 11.409,
    viewBox: "0 0 13.001 11.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffle);
export default __webpack_public_path__ + "static/media/shuffle.0ac4f896.svg";
export { ForwardRef as ReactComponent };